import { render, staticRenderFns } from "./AddContactDialog.vue?vue&type=template&id=459f811e&scoped=true"
import script from "./AddContactDialog.ts?vue&type=script&lang=js&external"
export * from "./AddContactDialog.ts?vue&type=script&lang=js&external"
import style0 from "./AddContactDialog.scss?vue&type=style&index=0&id=459f811e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459f811e",
  null
  
)

export default component.exports